<template>
  <div
    v-loading="isPageLoading"
    element-loading-text="页面数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="printBox">
      <div class="printOption">
        <hr class="hr-twill" />
        <ul class="dz-btn-group">
          <div class="configBox">
            <el-button
              class="button"
              icon="el-icon-circle-close"
              type="primary"
              plain
              size="medium"
              round
              @click="printCancel"
            >
              取消打印
            </el-button>
            <el-button
              class="button"
              :disabled="isBtnDisabled"
              icon="el-icon-printer"
              type="primary"
              plain
              size="medium"
              round
              @click="handleClickPrint"
              :loading="isBtnLoading"
            >
              确认打印
            </el-button>
          </div>
          <div class="configBox">
            <div class="print_config">
              <el-select
                size="medium"
                v-model="checkedTemplateId"
                placeholder="请选择打印模板"
                @change="checkedTemplateIdChange"
              >
                <el-option
                  v-for="item in templateOptions"
                  :key="item.id"
                  :label="item.templateName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </ul>
      </div>
      <hr class="hr-twill2" />
      <div
        class="perviewBox"
        v-loading="isPerviewLoading"
        element-loading-text="打印预览页面加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <div class="dz-preview-group">
          <!-- <div class="dz-preview" ref="preview-list"></div> -->
          <div class="containerBox"></div>
          <!-- 元素参数的 容器 -->
          <div id="PrintElementOptionSetting"></div>
        </div>
      </div>
      <hr class="hr-twill" />
    </div>
  </div>
</template>

<script>
import fontSize from "@/views/custom_data_management/print_template_test/hooks/fontSize";
import lineHeight from "@/views/custom_data_management/print_template_test/hooks/lineHeight";
import textAlign from "@/views/custom_data_management/print_template_test/hooks/textAlign";
import textContentVerticalAlign from "@/views/custom_data_management/print_template_test/hooks/textContentVerticalAlign";
import axios from 'axios';
// 工具
import {
  newHiprintPrintTemplate,
  getHiprintPrintTemplate,
} from "@/utils/template-helper";
import {
  getTemplateApi,
  previewApi,
  printApi,
} from "@/api/print_template_test";
import {create} from '@/api/print_logging';
let $ = require("jquery");
export default {
  name: "App",
  data() {
    return {
      isPageLoading: true,
      isPerviewLoading: false,
      isBtnDisabled: true,
      isBtnLoading: false,

      checkedTemplateId: null,
      templateOptions: [],
      templateRef: {},
      templateRefArr: [],
      printTemplateData:[]
    };
  },
  async created() {
    await this.templateQuery();
    if (this.templateOptions.length) {
      this.checkedTemplateId = this.templateOptions[0].id;
      this.checkedTemplateIdChange(this.checkedTemplateId);
    } else {
      this.$message({
        type: "info",
        message: "暂无可选择模板,请前往打印模板页面添加",
      });
    }
  },
  methods: {
    //预览渲染
    buildDesigner() {
      this.hiprintTemplate = newHiprintPrintTemplate("start-02", {
        template: this.templateRef, // 模板json(object)
        settingContainer: "#PrintElementOptionSetting", // 元素参数容器
      });
      hiprint.setConfig({
        // 加载 自定义/重写 的 参数 
        optionItems: [
          fontSize,
          lineHeight,
          textAlign,
          // textContentVerticalAlign
        ]
      })
      // let html = this.hiprintTemplate.getHtml([{'table':[
      //   {'wlbm':'dd','pc':'的方式发生','wlms':'ddeee'},
      //   {'wlbm':'dd','pc':'的方式发生','wlms':'ddeee'},
      //   {'wlbm':'dd','pc':'的方式发生','wlms':'ddeee'},
      //   {'wlbm':'dd','pc':'的方式发生','wlms':'ddeee'},
      //   {'wlbm':'dd','pc':'的方式发生','wlms':'ddeee'},
      // ]}]);
      let html = this.hiprintTemplate.getHtml(this.printTemplateData);
      do {
        setTimeout(() => {
          $(".containerBox").empty();
          $(".containerBox").html(html);
          let arr = $(".hiprint-printPanel.panel-index-0");
          arr.each(function (index) {
            $(this).attr("title", `当前页数第${index + 1}页,共${arr.length}页`);
            $(this).css("padding", "10px");
          });
          this.isPerviewLoading = false;
          this.isBtnDisabled = false;
        }, 200);
        return;
      } while ($(".containerBox").length <= 0);
    },
    //模板查询
    async templateQuery() {
      await getTemplateApi()
        .then((res) => {
          this.templateOptions = res || [];
        })
        .finally(() => {
          this.isPageLoading = false;
        });
    },
    //模板切换
    checkedTemplateIdChange(id) {
      this.isPerviewLoading = true;
      let printArr = sessionStorage.getItem("printArr");
      previewApi({
        templateId: id,
        data: printArr,
      })
        .then((res) => {
          let val = this.templateOptions.find((item) => item.id === id) || {};
          this.templateRef = { panels: [JSON.parse(val?.templateContent)] };

          let result = res && JSON.parse(res);
          this.templateRefArr = result.map((item) => ({ panels: item }));

          this.printTemplateData=result.map(item=>{
            return item.modules
          })
          console.log(this.printTemplateData)
          this.buildDesigner();
        })
        .catch((err) => {
          this.$message({ type: "error", message: err.message });
          this.isPerviewLoading = false;
        });
    },
    //确定打印
    handleClickPrint() {
      this.isBtnLoading = true;
      printApi({data:JSON.stringify(this.templateRefArr)})
        .then((res) => {
          axios.post('http://127.0.0.1:10006/print',res)
          .then(res=>{
            let printerParams=JSON.parse(sessionStorage.getItem('printerParams'));
            create({...printerParams,templateId:this.checkedTemplateId})
            .then(res=>{
              console.log(res)
            })
          })
        })
        .catch((err) => {
          this.$message({ type: "error", message: err.message });
        })
        .finally(() => {
          this.isBtnLoading = false;
        });
    },
    //取消打印
    printCancel() {
      window.opener = null;
      window.open("about:blank", "_top").close();
    },
  },
};
</script>
<style>
/* 不同模板 间隙 */
.containerBox .hiprint-printTemplate {
  background: #fff;
  border-bottom: 10px solid #ccc;
}
/* 批量打印 间隙 */
.containerBox .hiprint-printTemplate .hiprint-printPanel:not(:last-of-type) {
  border-bottom: 5px solid #ccc;
}
</style>
<style lang="scss" scoped>
html,
body,
div {
  height: 100%;
  margin: 0;
  padding: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
body {
  text-align: center;
}
.dz-title {
  font-weight: bold;
  font-size: 20px;
}
.dz-opt-group .dz-opt-item {
  display: flex;
  width: 400px;
  height: 28px;
  margin: 0 auto 10px auto;
}
.dz-opt-group .dz-opt-item .dz-opt-item-title {
  flex: 2;
  display: inline-block;
  text-align: right;
  background-color: lightblue;
  // margin: 5px;
  padding: 5px;
}
.dz-opt-group .dz-opt-item .dz-opt-item-value {
  flex: 5;
  background-color: lightyellow;
  max-width: 280px;
}
fieldset {
  width: 50%;
  margin: auto;
  min-height: 50px;
}
a {
  color: #42b983;
  cursor: pointer;
}
.button {
  cursor: pointer;
  // padding: 0.4em 2em !important;
  margin: 0.25em 0.5em;
  border-radius: 0.5em;
  display: inline-block;
  transition: all 0.15s ease;
  box-sizing: border-box;
  // border: 1px solid #4fc08d;
}
.perviewBox{
  height: 695px;
}
.dz-preview-group {
  user-select: none;
  padding-top: 5px;
  background-color: #F7F8F9;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset;
  border-radius: 2em 0 0 0;
  height: 690px;
  overflow-y: scroll;
  display: flex;
  justify-content: center;
  align-items: center;
}
.printBox {
  height: 100%;
  overflow: hidden;
  background-color: #F7F8F9;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset;
  border-radius: 2em 0 0 0;
  .printOption {
    box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
    // margin: 20px;
    height: 180px;
    .dz-btn-group {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 30px;
      .configBox {
        width: 500px;
        height: 60px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .print_config {
          line-height: 60px;
        }
        .button {
          display: inline-block;
          width: 250px;
          margin: 10px 10px 10px 0;
        }
      }
    }
  }
}
img:nth-last-of-type(1) {
  margin-bottom: 10px;
}
// .hr-double-arrow {
//     color: #d0d0d5;
//     border: double;
//     border-width: 3px 5px;
//     border-color: #d0d0d5 transparent;
//     height: 1px;
//     overflow: visible;
//     margin-left: 20px;
//     margin-right: 20px;
//     position: relative;
// }
// .hr-double-arrow:before,
// .hr-double-arrow:after {
//     content: '';
//     position: absolute;
//     width: 5px; height: 5px;
//     border-width: 0 3px 3px 0;
//     border-style: double;
//     top: -3px;
//     background: radial-gradient(2px at 1px 1px, currentColor 2px, transparent 0) no-repeat;
// }
// .hr-double-arrow:before {
//     transform: rotate(-45deg);
//     left: -20px;
// }
// .hr-double-arrow:after {
//     transform: rotate(135deg);
//     right: -20px;
// }
.hr-twill {
  border: 0;
  padding: 3px;
  // background: repeating-linear-gradient(
  //   135deg,
  //   #BDBEC5 0px,
  //   #A8A8B3 1px,
  //   transparent 1px,
  //   transparent 6px
  // );
}
.hr-twill:after {
  content: "打印操作区域";
  font-size: 18px;
  background: #c3c3ca;
  z-index: 2;
  position: absolute;
  left: 0;
  top: 0;
  color: white;
  padding: 10px 30px;
  // border: 1px solid gray;
  border-radius: 2em;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset,
    rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset;
}
.hr-twill2 {
  border: 0;
  padding: 3px;
  // background: repeating-linear-gradient(
  //   135deg,
  //   #BDBEC5 0px,
  //   #A8A8B3 1px,
  //   transparent 1px,
  //   transparent 6px
  // );
}
.hr-twill2:after {
  content: "打印预览视图";
  font-size: 18px;
  background: #c3c3ca;
  z-index: 2;
  position: absolute;
  left: 0;
  top: 210px;
  color: white;
  padding: 10px 30px;
  // border: 1px solid gray;
  border-radius: 2em;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset,
    rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset;
}
// .hr-mid-border-content::after{
//     content: attr(data-content);
//     position: absolute;
//     padding: 4px 1ch;
//     top: 50%; left: 50%;
//     transform: translate(-50%, -50%);
//     color: transparent;
//     border: 1px solid #d0d0d5;
// }
/* .addEdit .el-dialog {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0px !important;
} */
/* .ReadSendObject .el-dialog {
  left: 50%;
  top: 17%;
  transform: translate(-50%, -17%);
  margin: 0px !important;
} */
/* 美化滚动条 */
body {
  margin: 0;
  overflow: overlay;
}
::-webkit-scrollbar {
  background-color: transparent;
  width: 12px;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  background-clip: content-box;
  border: 2px solid transparent;
}
body[scroll]::-webkit-scrollbar-thumb,
::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
